export const TabState = {
  Past: "past",
  Upcoming: "upcoming",
  Disputed: "disputed",
  Close: "close",
};
